import React from "react";
import { withPrefix } from "gatsby";
import styles from "./project-template.module.scss";

function Project(props) {
  const { title, description, thumbnail, tags, github, live } = props.data;
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <img
        className={styles.image}
        src={withPrefix(thumbnail)}
        alt={description}
      />
      <div className={styles.box}>
        <a
          className={styles.box__link}
          href={github}
          target="_blank"
          rel="noopener noreferrer"
        >
          Github
        </a>
        <a
          className={styles.box__link}
          href={live}
          target="_blank"
          rel="noopener noreferrer"
        >
          Live
        </a>
      </div>
      <p className={styles.description}>{description}</p>
      <ul className={styles.list}>
        {tags.map((tag, index) => (
          <li className={styles.list__item} key={index}>
            {tag}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Project;
